import React, { useEffect, useState } from "react";
import { Button, Table, Tag, Spin } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import getActiveMerchantInvoice from "functions/merchant/getActiveMerchantInvoice";
import moneyFormat from "functions/utils/moneyFormat";
import InvoicePreview from "components/modal/merchantInvoicePreview";
import CountPreview from "components/modal/merchantInvoiceCountPreview";
import { VatPreview } from "components/modal/vatPreview";
import MerchantPaidInvoiceList from "components/lists/merchantPaidInvoice";
import { bg_button, bg_shadow } from "constant/css";
import { getMerchantId } from "service/storage";

const XpayPayment = () => {
  const merchantId = getMerchantId();
  const [invoiceDetail, setInvoiceDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewOpen, setPreviewOpen] = useState(null);
  const [countPreviewOpen, setCountPreviewOpen] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const active = await getActiveMerchantInvoice(merchantId);
        setInvoiceDetail(active[0] || null);
      } catch (error) {
        console.error("API Load Error:", error);
      } finally {
        setLoading(false);
      }
    };
    if (merchantId) fetchData();
  }, [merchantId]);
  const showPreview = (id) => {
    setPreviewOpen(id);
  };
  const showCountDetail = (id) => {
    setCountPreviewOpen(id);
  };

  return (
    <Spin
      spinning={loading}
      size="large"
      className="flex justify-center custom-green-spin"
    >
      <div className="min-h-screen bg-white p-8">
        <div className={`max-w-6xl ${bg_shadow} mx-auto mb-8   rounded-xl p-6`}>
          {invoiceDetail ? (
            <div className="flex items-center justify-between">
              <div className="flex items-start gap-3 flex-col justify-between">
                <Tag color={"cyan"}>Идэвхтэй нэхэмжлэл </Tag>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Смартбиллинг ХХК
                  </h2>
                  <h2 className="text-lg text-gray-800">
                    <span className="text-gray-400 text-sm">
                      {" "}
                      {invoiceDetail?.description}
                    </span>
                  </h2>
                </div>
                <div className="text-xl font-bold text-[#4ca693]">
                  {moneyFormat(invoiceDetail?.total)} ₮
                </div>
              </div>

              <div className="mt-6 justify-center items-center flex gap-4 justify-end flex-col">
                <Button
                  icon={<EyeOutlined />}
                  onClick={() => showCountDetail(invoiceDetail?.id)}
                  className={`${bg_button} ${bg_shadow} px-5 py-2 text-gray-100 rounded-lg border border-transparent hover:shadow-[0_6px_16px_rgba(40,167,69,0.5)]`}
                >
                  Билл мэдээлэх үйлчилгээний хүрээ
                </Button>
                <Button
                  onClick={() => showPreview(invoiceDetail?.id)}
                  icon={<EyeOutlined />}
                  className={`${bg_button} ${bg_shadow} bg-[#fff] w-[200px] text-gray-100 px-5 py-2 rounded-lg border border-transparent shadow-[0_4px_12px_rgba(40,167,69,0.4)] hover:shadow-[0_6px_16px_rgba(40,167,69,0.5)]`}
                >
                  Нэхэмжлэл авах
                </Button>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <h2 className="text-lg font-semibold text-gray-800">
                Идэвхтэй нэхэмжлэл байхгүй байна
              </h2>
              <p className="text-sm text-gray-500">
                Нэхэмжлэл мэдээлэл aвах бол contact@smartbilling.mn
              </p>
            </div>
          )}
        </div>
        {previewOpen && (
          <InvoicePreview
            open={previewOpen}
            close={() => setPreviewOpen(null)}
            invoiceId={previewOpen}
          />
        )}
        {countPreviewOpen && (
          <CountPreview
            open={countPreviewOpen}
            close={() => setCountPreviewOpen(null)}
            invoiceId={countPreviewOpen}
          />
        )}
        <MerchantPaidInvoiceList />
      </div>
    </Spin>
  );
};

export default XpayPayment;
